import moment from 'moment';
import { applyUkgUserTimeZoneTransformation, correctBrowserTimezone } from '@commonClient2/services/ukgDateTime';
import DateFormatService from '@services/DateFormatService';
import { UkgDateFormat } from '@enums/UkgDateFormat';
/**
 * @param {number} timeUnit
 */
const addLeadingZeros = (timeUnit) => (timeUnit >= 10 ? timeUnit : `0${timeUnit}`);

class TimeService {
    /**
     * @param {number} time
     */
    calculateTimes = (time) => {
        const date = new Date();
        date.setHours(0, 0, 0, 0); // Reset to start of day
        date.setSeconds(time); // Set the seconds
        
        return this.formatDate(date);
    };

    /**
     * @param {number} startTime
     * @param {number} endTime
     */
    calculateShiftTimes = (startTime, endTime) => `${this.calculateTimes(startTime)} - ${this.calculateTimes(endTime)}`;

    /**
     * @param {Date} date
     */
    formatDate = (date) => (date ? DateFormatService.formatDateOrEmpty(date, UkgDateFormat.TimeFormat) : '');

    /**
     * @param {number} time
     */
    formatSecondsInMinSec = (time) => {
        if (time < 0) {
            return '00:00';
        }
        const minutes = Math.floor(time / (1000 * 60));
        const seconds = Math.floor((time - (minutes * (1000 * 60))) / 1000);
        return `${addLeadingZeros(minutes)}:${addLeadingZeros(seconds)}`;
    };

    /** @param {Date}  time */
    getTimeDiffFromNowInDays = (time) => {
        const convertedDate = applyUkgUserTimeZoneTransformation(time);
        return moment(convertedDate).startOf('day').diff(moment().startOf('day'), 'days');
    };

    /**
     * @param {number} minutes
     * @returns {Date}
     */
    getDateTimeFromMinutes = (minutes) => {
        const today = new Date();
        today.setHours(0, minutes, 0, 0);
        return today;
    };

    /**
     * @param {number} startTime
     * @param {number} endTime
     */
    getTimeDifference = (startTime, endTime) => (
        (endTime - startTime) / 60 / 60
    );
}

export default (new TimeService());
